/* Valida se um campo checkbox / boolean foi marcado como true */
const checked = (value, options) => {
  if (value !== true) {
    return options.message || 'must be checked';
  }
};

export default {
  checked
};
